import React from "react";
import "./About.css"; 
import aboutImage from '../images/about.jpg';

import aboutImages from '../images/about_1.webp';

function About() {
  return (

 <>
 
 <div className="about-section-wrapper">
  <div className="image-wrapper">
    <img src={aboutImage} alt="Chennai Home Appliance Care" className="about-image" />
  </div>
  <div className="content-wrapper">
    <div className="content-left">
      <h2 className="section-title">About Us</h2>
      <p className="section-description">
        Welcome to <strong>Chennai Home Appliance Care</strong>, your reliable and professional partner for washing machine repairs, fridge services, and home appliance maintenance in Chennai.
      </p>
      
      <button
        className="contact-btn"
        onClick={() => (window.location.href = 'tel:+918270096596')}
      >
        Call Us:  82700 96596
      </button>
    </div>
  </div>


</div>
  <div className="about-us-container">
  <div className="about-content-wrapper">
    <div className="image-column-wrapper">
      <img src={aboutImages} alt="Chennai Home Appliance Care" className="about-image" />
    </div>
    <div className="text-column-wrapper">
      <h2 className="about-title">About Chennai Home Appliance Care</h2>
      <p className="about-description">
        Welcome to <strong>Chennai Home Appliance Care</strong>, your trusted partner for expert home appliance services. We specialize in the repair, maintenance, and installation of washing machines, refrigerators, air conditioners, and more. 
        Our team of skilled technicians ensures that your appliances are running smoothly and efficiently, providing you with reliable and affordable solutions for all your appliance needs.
      </p>
      <p className="about-description">
        At Chennai Home Appliance Care, customer satisfaction is our top priority. With years of experience in the industry, our technicians are trained to handle any appliance repair with precision and care. Whether it's a quick fix or a comprehensive repair, we ensure that each service is completed to your satisfaction.
      </p>
      <p className="about-description">
        Choose us for quality service that exceeds expectations, with guaranteed results and timely repairs. Trust us to keep your home appliances in top condition so that you can focus on what matters most.
      </p> 
    </div>
  </div>
</div>
 
  </>
    
  );
}

export default About;
